import type { AffectedProvision } from '../types/watchdog';

const EVIDENCE_LABELS: Record<AffectedProvision['evidence_type'], string> = {
  direct_textual: 'přímý citát',
  institutional_inference: 'institucionální inference',
  hypothetical_abuse: 'hypotetické zneužití',
  uncertainty: 'nejistota',
};

interface Props {
  provisions: AffectedProvision[];
}

export function AffectedProvisionsList({ provisions }: Props) {
  if (provisions.length === 0) return null;
  return (
    <section className="affected-provisions-list">
      <h4>Dotčené pasáže zákona</h4>
      {provisions.map((p) => (
        <div key={p.section_id} id={`provision-${p.section_id.replace(/\s+/g, '-')}`} className="affected-provision-card">
          <div className="affected-provision-card__header">
            <span className="affected-provision-card__section-id">{p.section_id}</span>
            {p.section_title && <span className="affected-provision-card__title">{p.section_title}</span>}
            <span className={`affected-provision-card__evidence-type affected-provision-card__evidence-type--${p.evidence_type}`}>
              {EVIDENCE_LABELS[p.evidence_type]}
            </span>
          </div>
          {p.quoted_text && (
            <blockquote className="affected-provision-card__quote">{p.quoted_text}</blockquote>
          )}
          <p className="affected-provision-card__concern">{p.democratic_concern}</p>
        </div>
      ))}
    </section>
  );
}
